module.exports = __webpack_public_path__ + "img/aiki.2097d298.jpg";